import Component from './HeaderTitle.component';

export default Component;
